import type { ReactNode } from "react";

interface SegmentHeaderProps {
  title: string;
  description?: string;
  right?: ReactNode;
}

/**
 * A segment's header, inside that segment's `<CardHeader>` — title and description together,
 * with an optional action on the right (e.g. "+ Add Condition"). No numeral badge — Manage
 * Capital's 4 segments read top to bottom as a plain list of cards, not a numbered sequence.
 */
export function SegmentHeader({ title, description, right }: SegmentHeaderProps) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h3 className="text-sm font-semibold">{title}</h3>
        {description && (
          <p className="mt-0.5 max-w-2xl text-xs text-muted-foreground">{description}</p>
        )}
      </div>
      {right && <div className="flex shrink-0 items-center gap-2">{right}</div>}
    </div>
  );
}
